import React, { useMemo } from 'react'
import styled from 'styled-components'

const VariableSizeBox = React.forwardRef(
	(
		// eslint-disable-next-line react/prop-types
		{ children, className, defaultHeight, defaultWidth, width },
		ref
	) => {
		const scale = useMemo(() => width / defaultWidth, [defaultWidth, width])

		const ratio = useMemo(() => (defaultHeight / defaultWidth) * 100, [
			defaultHeight,
			defaultWidth,
		])

		return (
			<Container
				ratio={ratio}
				style={{ width }}
				className={className}
				ref={ref}
			>
				<Box
					style={{ transform: `scale(${scale})` }}
					width={defaultWidth}
					height={defaultHeight}
				>
					{children}
				</Box>
			</Container>
		)
	}
)

const Container = styled.div`
	position: relative;
	::before {
		content: '';
		display: block;
		padding-top: ${(props) => `${props.ratio}%`};
	}
`

const Box = styled.div`
	transform-origin: 0% 0%;
	width: ${(props) => `${props.width}px`};
	height: ${(props) => `${props.height}px`};
	position: absolute;
	top: 0;
`

export default VariableSizeBox
